import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FileActions, IeDsFile, IeDsFolder, IeDsResource, IFileAction, iseDsFile} from '../../../models/user-info';
import {DataSource} from '@angular/cdk/table';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {UserProjectsActionsDialogComponent} from 'app/components/nav-catalog/user-projects-actions-dialog/user-projects-actions-dialog.component';
import {isArray, isNullOrUndefined} from 'util';
import {BehaviorSubject, Observable} from "rxjs";

@Component({
  selector: 'edsng-user-projects-table',
  templateUrl: './user-projects-table.component.html',
  styleUrls: [
    './user-projects-table.component.css',
    './user-projects-table.component.mobile.css',
    './user-projects-table.component.tablet.css'
  ]
})
export class UserProjectsTableComponent implements OnInit {

  displayedColumns = ['fileName', 'creationDate', 'description', 'action'];
  dataSource: UserFileDataSource | null;
  _selectedItem: IeDsResource | null = null;
  db$: BehaviorSubject<IeDsResource[]> = new BehaviorSubject<IeDsResource[]>([]);

  @Input() showFiles = true;
  @Input() isMyProjects: boolean;           // MyProject --> if false available only open (Read only)
  @Input() showTable: boolean = true;
  @Input() currentFolder:  BehaviorSubject<IeDsFolder[]> = new BehaviorSubject<IeDsFolder[]>([]);
  @Output() fileEvent: EventEmitter<IFileAction> = new EventEmitter<IFileAction>();

  withExport: boolean = false;
  withDelete: boolean = false;
  withRename: boolean = false;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
    this.dataSource = new UserFileDataSource(this.db$);
    this.currentFolder.subscribe(x => this.updateFolderView(x.reduce((acc, it) => it, null)));
    if (this.isMyProjects) {
      this.withDelete = true;
      this.withRename = true;
      this.withExport = true;
    }
  }

  jumpFolder(item: IeDsFolder) {
    // navigate in the subfolder from breadcrumbs
    this.fileEvent.emit({action: 'open', file: item});
  }

  updateFolderView(item: IeDsFolder) {
     // console.log('updateFolderView', item);
    this._selectedItem = null;
    if (item !== null) {
      const toList = (a: any | any[]| null | undefined) => !isNullOrUndefined(a) ?  (isArray(a) ? a : [a]) : [];
      const _files = toList(item.file);
      const _folders = toList(item.folder);

      _folders.sort((a, b) => a.label.localeCompare(b.label));
      _files.sort((a, b) => a.label.localeCompare(b.label));

      const __db = this.showFiles ? _folders.concat(_files) : _folders;
      // console.log('UpdateView2', _folders, _files, __db);
      this.db$.next(__db);
    } else {
      // console.log('UpdateView 3', 'empty table');
      this.db$.next([]);
    }
  }

  iseDsFile(row: IeDsResource): boolean {
    return iseDsFile(row);
  }

  selectRow(event: any, row: IeDsFile) {
    // console.log('Select row', row);
    /**
     * Se si clicca su una riga degli esempi
     */
    // event.stopPropagation();
    this._selectedItem = row;

    // if (window.innerWidth + 16 <= 1023) {
    //   this.openFile(this._selectedItem);
    // }
  }

  /**
   * Funzione che viene triggerata per mostrare le azioni in versione mobile
   */
  showActions(row: IeDsFile) {
    const config = new MatDialogConfig();
    config.position = {
      bottom: '0px',
      left: '0px',
      right: '0px'
    };
    config.width = '100%';
    const dialogRef = this.dialog.open(
      UserProjectsActionsDialogComponent,
      config
    );
    dialogRef.componentInstance.withOpen = true;
    dialogRef.componentInstance.withExport = this.withExport && !row.isFolder;
    dialogRef.componentInstance.withDelete = this.withDelete;
    dialogRef.componentInstance.withRename = this.withRename;

    dialogRef.afterClosed().subscribe(x => {
      switch (x) {
        case 'open':
        case 'rename':
        case 'delete':
        case 'export':
          this.emitFileEvent(x, row);
      }
    });

  }

  selectDoubleClick(item: IeDsFile) {
    this.emitFileEvent('open', item);
  }

  emitFileEvent(action: FileActions, f: IeDsResource = null) {
    const _f = (f) ? f : this._selectedItem;
    if ( _f ) {
      this.fileEvent.emit({action, file: _f});
    }
  }

}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, UserFileDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
class UserFileDataSource extends DataSource<any> {
  constructor(private db: BehaviorSubject<IeDsResource[]>) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<IeDsResource[]> {
    return this.db;
  }

  disconnect() {}
}
